import { IMedia } from '@shared/Types'
import { Typography } from '@mui/material'
import { TableFormater } from '@lib/Helpers'
import { MediaStatusCell } from '@shared/Pages/Media'
import { CreateTableTemplate, MapOprators } from '@lib/Table'

export const GetTable = () => {
  return CreateTableTemplate<IMedia>('Redux', {
    getRowId: (x) => x.Id,
    config: {
      Name: { type: 'string', flex: 3, minWidth: 250 },
      Extension: { type: 'string', flex: 1, minWidth: 110 },
      ResourceId: { type: 'string', headerName: 'Resource ID', flex: 1 },
      Type: { type: 'string', flex: 1, minWidth: 110, filterable: false },
      Size: {
        type: 'number',
        minWidth: 100,
        flex: 1,
        headerAlign: 'left',
        renderCell: (params) => (
          <Typography variant='subtitle2' sx={{ pr: '9px' }}>
            {TableFormater.formatSize(params.value)}
          </Typography>
        )
      },
      Duration: { type: 'string', minWidth: 110, flex: 1, filterable: false, valueFormatter: (params) => TableFormater.formatDuration(params.value) },
      DateCreated: {
        type: 'string',
        headerName: 'Date created',
        minWidth: 190,
        filterable: false,
        renderCell: (params) => TableFormater.tooltipDate(params.value)
      },
      Status: { type: 'string', minWidth: 130, filterable: false, renderCell: (params) => <MediaStatusCell data={params.value} /> }
    },
    filterOperators: MapOprators, //server mode,
    minWidthColumnActions: 175
  })
}
